// import React, { useState } from "react";
import React, { useState , useEffect} from "react";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { startSessionIdleMonitor, stopSessionIdleMonitor } from "./utils/sessionManager";
// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import SideNav from "./components/SideNav";
import MainLayout from "./layouts/MainLayout";
import ProtectedRoute from "./components/ProtectedRoute";

// Pages
import DashBoard from "./pages/DashBoard.js";
import Profile from "./pages/Profile.js";
import User from "./pages/User.js";
import DisabledUser from "./pages/DisabledUser.js";
import CourseVideo from "./pages/CourseVideo.js";
import AppImageSlider from "./pages/AppImageSlider.js";
import Login from "./components/Login.js";
import CourierInformation from "./pages/CourierInformation.js";
import Diagnoses from "./pages/Diagnoses.js";
import NewEntry from "./pages/NewEntry.js";
import ViewEntry from "./pages/ViewEntry.js";
import PatientList from "./pages/PatientList.js";
import PatientNotepad from "./pages/PatientNotepad.js";
import PendingAppointment from "./pages/PendingAppointment.js";
import CompletedAppointment from "./pages/CompletedAppointment.js";
import RejectedAppointment from "./pages/RejectedAppointment.js";
import SlotList from "./pages/SlotList.js";
import OrderList from "./pages/OrderList.js";
import LeadManagement from "./pages/LeadManagement.js";
import FullReport from "./pages/FullReport.js";
import LocalNotepad from "./pages/LocalNotepad.js";
import InvoiceList from "./pages/InvoiceList.js";
import WetaOrderList from "./pages/WetaOrderList.js";
import PatientDetails from "./pages/PatientDetails.js";
import EditPatient from "./pages/EditPatient.js";
import AssignPage from "./pages/AssignPage.js";
import Branch from "./pages/Branch.js";
import AssignBranch from "./pages/AssignBranch.js";
import LeadDetails from "./pages/LeadDetails.js";
import EditMorePatient from "./pages/EditMorePatient.js";
import AddDiagnosis from "./pages/AddDiagnosis.js";
import EditDiagnosis from "./pages/EditDiagnosis.js";
import AddNote from "./pages/AddNote.js";
import OrderDetails from "./pages/OrderDetails.js";
import GenerateInvoice from "./pages/GenerateInvoice.js";
import EditInvoice from "./pages/EditInvoice.js";
import RelativesPage from "./pages/RelativesPage.js";
import InvoicePrint from "./pages/InvoicePrint.js";
import AddUserPage from "./pages/AddUserPage.js";
import EditUserPage from "./pages/EditUserPage.js";
import LocalNote from "./pages/LocalNote.js";
import AddInvoice from "./pages/AddInvoice.js";
import EditPatientInvoice from "./pages/EditPatientInvoice.js";
import Product from "./pages/Product.js";
import NewProductEntry from "./pages/NewProductEntry.js";
import Category from "./pages/Category.js";
import NewProductEdit from "./pages/NewProductEdit.js";
import Courier from "./pages/Courier.js";
// import CourierMaster from "./pages/CourierMaster.js";
import CourierEntry from "./pages/CourierEntry.js";
import CategoryEdit from "./pages/CategoryEdit.js";
import CourierEntryList from "./pages/CourierEntryList.js";
import CourierEntryEdit from "./pages/CourierEntryEdit.js";
import AddNotepad from "./pages/AddNotepad.js";
import AddLocalNotepad from "./pages/AddLocalNotepad.js";
import AddCourse from "./pages/AddCourse.js";
import AllActivities from "./pages/AllActivities.js";
import AgeingSearch from "./pages/AgeingSearch.js";
import AgeingResults from "./pages/AgeingResults.js";
import CourierIntegration from "./pages/CourierIntegration.js";
import CourierIntegrationList from "./pages/CourierIntegrationList.js";
import EditLocalNotepad from "./pages/EditLocalNotepad.js";
import Staff from "./pages/Staff.js";
import ProductSalesReport from "./pages/ProductSalesReport";

function App() {
  const [submittedData, setSubmittedData] = useState([]);
useEffect(() => {
    startSessionIdleMonitor();
    return () => {
      stopSessionIdleMonitor();
    };
  }, []);
  const handleFormSubmit = (newEntry) => {
    setSubmittedData((prevData) => [...prevData, newEntry]);
  };

  return (
    <Router>
      <div className="App">
        {/* Global Toast Container */}
        {/* <ToastContainer /> */}
              <ToastContainer position="top-center" autoClose={2000} />


        <Routes>
          {/* Public Route (Login) */}
          <Route path="/" element={<Login />} />

          {/* 🔒 Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <DashBoard />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Profile />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/user"
            element={
              <ProtectedRoute requiredPermission={{ category: 'master', permission: 'user' }}>
                <MainLayout>
                  <User />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/disableduser"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <DisabledUser />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/courierinformation"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CourierInformation />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/diagnoses"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Diagnoses />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/AddDiagnosis"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AddDiagnosis />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/EditDiagnosis/:diagnosis_id"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <EditDiagnosis />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/coursevideo"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CourseVideo />
                </MainLayout>
              </ProtectedRoute>
            }
          />
           <Route
            path="/staff"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Staff />
                </MainLayout>
              </ProtectedRoute>
            }
          />
<Route
  path="/product-sales-report"
  element={
    <ProtectedRoute>
      <MainLayout>
        <ProductSalesReport />
      </MainLayout>
    </ProtectedRoute>
  }
/>
          <Route
            path="/appimageslider"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AppImageSlider />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/Category"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Category />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/CourierMaster"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CourierMaster />
                </MainLayout>
              </ProtectedRoute>
            }
          /> */}

          <Route
            path="/CourierEntry"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CourierEntry />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/CourierEntryList"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CourierEntryList />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/CourierEntryEdit"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CourierEntryEdit />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/Courier"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Courier />
                </MainLayout>
              </ProtectedRoute>
            }
          /><Route
            path="/CategoryEdit/:category_id"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CategoryEdit />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/NewEntry"
            element={
              <ProtectedRoute requiredPermission={{ category: 'operation', permission: 'addpatiententry' }}>
                <MainLayout>
                  <NewEntry onSubmit={handleFormSubmit} />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/ViewEntry"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <ViewEntry data={submittedData} />
                </MainLayout>
              </ProtectedRoute>
            }
          />


          <Route
            path="/PatientList"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <PatientList />
                </MainLayout>
              </ProtectedRoute>
            }
          />
            <Route
            path="/AllActivities"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AllActivities />
                </MainLayout>
              </ProtectedRoute>
            }
          />
           <Route
            path="/CourierIntegration"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CourierIntegration />
                </MainLayout>
              </ProtectedRoute>
            }
          />
            <Route
            path="/CourierIntegrationList"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CourierIntegrationList />
                </MainLayout>
              </ProtectedRoute>
            }
          />
                 <Route
            path="/AgeingSearch"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AgeingSearch />
                </MainLayout>
              </ProtectedRoute>
            }
          />
                <Route
            path="/AgeingResults/:days"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AgeingResults />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/AddCourse/:patient_id"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AddCourse />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/PatientNotepad"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <PatientNotepad />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/AddNotepad"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AddNotepad />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/NewProductEntry"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <NewProductEntry />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/NewProductEdit/:product_id"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <NewProductEdit />
                </MainLayout>
              </ProtectedRoute>
            }
          />


          <Route
            path="/patient/:patient_id/add-note"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AddNote />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/patient/:patient_id/LocalNote"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <LocalNote />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/EditLocalNotepad/:id"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <EditLocalNotepad/>
                </MainLayout>
              </ProtectedRoute>
            }
          />


          <Route
            path="/PendingAppointment"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <PendingAppointment />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/CompletedAppointment"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CompletedAppointment />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/RejectedAppointment"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <RejectedAppointment />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/SlotList"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <SlotList />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/OrderList"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <OrderList />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/OrderDetails/:orderId"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <OrderDetails />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/LeadManagement"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <LeadManagement />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/FullReport"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <FullReport />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/LocalNotepad"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <LocalNotepad />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/AddLocalNotepad"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AddLocalNotepad />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/InvoiceList"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <InvoiceList />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/GenerateInvoice"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <GenerateInvoice />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/EditInvoice/:invoice_id"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <EditInvoice />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/EditPatientInvoice/:invoice_id"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <EditPatientInvoice />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/WetaOrderList"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <WetaOrderList />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/Branch"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Branch />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/Product"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Product />
                </MainLayout>
              </ProtectedRoute>
            }
          />


          <Route
            path="/patient/edit/:patient_id"
            element={
              <ProtectedRoute requiredPermission={{ category: 'operation', permission: 'editpatiententry' }}>
                <MainLayout>
                  <EditPatient />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/EditMorePatient/:patient_course_id"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <EditMorePatient />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/patient/details/:patient_id"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <PatientDetails />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/assign/:patient_id"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AssignPage />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/assign-branch/:patient_id"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AssignBranch />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/LeadDetails/:id"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <LeadDetails />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/RelativesPage/:patient_id"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <RelativesPage />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/InvoicePrint/:invoice_id"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <InvoicePrint />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/AddInvoice/:patient_id"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AddInvoice />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/AddUserPage"
            element={
              <ProtectedRoute requiredPermission={{ category: 'master', permission: 'adduser' }}>
                <MainLayout>
                  <AddUserPage />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/EditUserPage/:user_id"
            element={
              <ProtectedRoute requiredPermission={{ category: 'master', permission: 'edituser' }}>
                <MainLayout>
                  <EditUserPage />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          {/* Standalone Components (optional) */}
          <Route path="/sidenav" element={<SideNav />} />
          <Route path="/header" element={<Header />} />
          <Route path="/footer" element={<Footer />} />

        </Routes>
      </div>
    </Router>
  );
}
export default App;





